import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { percentOf } from '../../common/SplitProgressBarChart/util';
import Indicator from '../../common/SplitProgressBarChart/Indicator';

type ProgressBarProps = {
  metColor: string;
  notMetColor: string;
  metDescription?: any;
  MetEndAdornment?: any;
  notMetDescription?: any;
  NotMetEndAdornment?: any;
  descriptionWidth?: any;
  title: React.ReactNode | string;
  completedAndMet: number;
  total: any;
  unmet: any;
};

const StudentLargeProgressBar = ({
  metColor,
  notMetColor,
  metDescription,
  notMetDescription,
  NotMetEndAdornment,
  MetEndAdornment,
  title,
  completedAndMet,
  unmet
}: ProgressBarProps) => {
  const classes = useStyles();
  const mainRef: any = React.useRef(null);

  return (
    <Box display="flex" flex={1} flexDirection="column" position="relative" marginBottom={3}>
      <Box display="flex" flexDirection="row" justifyContent="space-between" marginBottom="2px">
        {title}
      </Box>

      <div
        ref={mainRef}
        className={classes.notMet}
        style={{ width: '100%', backgroundColor: unmet === 0 ? metColor : notMetColor }}
      >
        {completedAndMet > 0 && <Indicator color={metColor} style={{ height: 68 }} />}
      </div>
      <Box
        className={classes.met}
        width={`${percentOf(completedAndMet, completedAndMet + unmet)}%`}
        style={{
          backgroundColor: metColor,
          ...(unmet === 0 && { borderTopRightRadius: 8, borderBottomRightRadius: 8 })
        }}
      >
        <Box display="flex" flex={1}>
          <Typography style={{ color: '#fff', marginLeft: 8 }}>{completedAndMet}</Typography>
        </Box>
        <Box display="flex">
          {unmet > 0 && <Indicator color={notMetColor} />}
          <Typography style={{ color: '#fff', position: 'absolute', marginLeft: '8px' }}>
            {unmet}
          </Typography>
        </Box>
      </Box>

      <Box display="flex" flex={1}>
        <Typography
          noWrap
          style={{
            display: 'flex',
            marginLeft: 11,
            fontSize: 18,
            alignItems: 'flex-end',
            marginTop: 25
          }}
        >
          {completedAndMet > 0 && (
            <>
              {metDescription}
              {MetEndAdornment}
            </>
          )}
        </Typography>
        {unmet > 0 && (
          <Typography
            className="notMetDescription"
            style={{
              display: 'flex',
              width: '10',
              fontSize: 18,
              marginLeft: `${percentOf(completedAndMet, completedAndMet + unmet) + 3}%`,
              position: 'absolute',
              whiteSpace: 'nowrap',
              verticalAlign: 'center'
            }}
          >
            {notMetDescription}
            {NotMetEndAdornment}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  notMet: {
    display: 'flex',
    height: 22,
    borderRadius: '8px'
  },
  met: {
    display: 'flex',
    height: 22,
    justifyContent: 'flex-end',
    borderRadius: '8px 0px 0px 8px',
    marginTop: -22
  },
  icon: {
    marginLeft: 2
  }
}));
export default StudentLargeProgressBar;
